/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return key in Object(object);
}

module.exports = baseHasIn;



//////////////////
// WEBPACK FOOTER
// ./~/why-did-you-update/~/lodash/_baseHasIn.js
// module id = 702
// module chunks = 0